acelerador.component('acelerador.aceleradorComponent', {
    templateUrl: 'acelerador/acelerador.html',
    controller: 'acelerador.aceleradorController',
    controllerAs: '$ctrl'
});

acelerador.controller('acelerador.aceleradorController', ['$rootScope', '$scope', '$state', 'coreFb', 'coreLanguage', '$sce', '$filter', '$timeout', function($rootScope, $scope, $state, $fb, $text, $sce, $filter, $timeout){
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.filter = {
        idProduto: null,
        idModulo:null
    };

    const _getAreaMembros=async(idArea)=>{

        let doc = await $fb.db.get(`cad_areaMembros/${idArea}`);
            
        $ctrl.guia = doc.data.guia;

        $ctrl.produtos = [];

        for(let prod of doc.data.produtos){

            let produto = await $fb.db.get(`cad_produtos/${prod.id}`);
            let modulos = await $fb.db.list(`cad_produtos/${prod.id}/modulos`);

            if(produto.arquivado || !produto.data){
                continue;
            }

            $ctrl.produtos.push({ 
                nome: produto.data.nome, 
                id: produto.id, 
                modulos: $filter('orderBy')(modulos.map(item=>{ return {id:item.id, nome: item.data.nome, ordem: item.data.ordem} }), 'ordem')
            });
        };

        try{
            $ctrl.filter.idProduto = $ctrl.produtos[0].id;
            $ctrl.filter.idModulo = $ctrl.produtos[0].modulos[0].id;

        }catch(e){
            $ctrl.filter = {};
        }

        _getFaq(doc.data.guia.idFaq);

        $state.params.showGlobalLoading = false;
        $scope.$apply();
    };

    const _getFaq=(idFaq)=>{

        $fb.db.get(`cad_faq/${idFaq}`).then(doc=>{
            $ctrl.faq = doc;

            return $fb.db.list(`cad_faq/${idFaq}/artigos`);
        }).then(list=>{
            $ctrl.faqItems = list.map(item=>{
                return {
                    ...item,
                    _shortDesc: item.data.descricao.length > 100 ? $ctrl.trust(item.data.descricao.substring(0, 100) + '...') : $ctrl.trust(item.data.descricao),
                }
            });

        });

    };

    $ctrl.setView=(value)=>{
        $ctrl.chatConfig = value !== 'bot' ? null : {
            ...$ctrl.guia.hypebot,
            idProduto: $ctrl.filter.idProduto
        }

        $ctrl.viewMode=value;
    };

    $ctrl.trust=(value)=>{
        return $sce.trustAsHtml(value);
    };

    $ctrl.viewFaqItem=(idArtigo)=>{
        $state.go('cliente.aceleradorDetalhe', {idFaq: $ctrl.guia.idFaq, idArtigo:idArtigo});
    };

    $ctrl.setChatConfig=()=>{
        $ctrl.chatConfig = false;        
        $timeout(()=>{ $ctrl.setView('bot'); }, 300);
    };

    $ctrl.$onInit = () => {
        $rootScope.idAreaMembros = $fb.auth.getIdToken().claims.idAreaMembros;
        
        _getAreaMembros($rootScope.idAreaMembros).then(okay=>{
            $ctrl.setView('faq');
        });

        $scope.isDesktop = $rootScope.isDesktop;
    }

}]);